import { useState } from "react";
import { motion } from "framer-motion";
import { Quote } from "lucide-react";
import { useLang } from "../i18n";
import { Reveal, scrollToId } from "./Reveal";

export const CaseStudy = () => {
  const { t } = useLang();
  const c = t.story;

  return (
    <section id="story" className="relative py-24 lg:py-32 border-t border-line overflow-hidden">
      <div
        className="absolute inset-0 pointer-events-none"
        style={{ background: "radial-gradient(900px 500px at 85% 30%, rgba(0,75,147,0.28), transparent 60%)" }}
      />
      <div className="relative mx-auto max-w-7xl px-4 sm:px-6">
        <Reveal>
          <p className="mono-label">{c.eyebrow}</p>
          <h2 className="mt-4 font-display uppercase font-bold tracking-tight leading-[0.95] text-3xl sm:text-4xl lg:text-5xl max-w-3xl">
            {c.heading}
          </h2>
        </Reveal>

        <div className="mt-12 grid lg:grid-cols-12 gap-5">
          <Reveal className="lg:col-span-4 card-surface p-8 relative overflow-hidden">
            <Quote size={22} className="text-hadron-green" />
            <p className="mt-4 mono-label !text-[9px] !text-hadron-green">{c.challengeLabel}</p>
            <p className="mt-3 text-sm lg:text-base text-txt leading-relaxed">{c.challenge}</p>
          </Reveal>
          <Reveal delay={0.1} className="lg:col-span-4 card-surface p-8 relative overflow-hidden">
            <Quote size={22} className="text-hadron-cyan" />
            <p className="mt-4 mono-label !text-[9px]">{c.buildLabel}</p>
            <p className="mt-3 text-sm lg:text-base text-txt-2 leading-relaxed">{c.build}</p>
          </Reveal>
          <Reveal delay={0.2} className="lg:col-span-4 card-surface p-8 relative overflow-hidden">
            <Quote size={22} className="text-hadron-green" />
            <p className="mt-4 mono-label !text-[9px] !text-hadron-green">{c.resultLabel}</p>
            <p className="mt-3 text-sm lg:text-base text-txt leading-relaxed">{c.result}</p>
          </Reveal>
        </div>

        <Reveal delay={0.25} className="mt-5 card-surface p-6 lg:p-7 flex flex-wrap items-center justify-between gap-5">
          <div className="flex flex-wrap gap-2.5">
            {c.chips.map((chip) => (
              <span key={chip} className="border border-hadron-cyan/40 bg-hadron-cyan/10 px-3 py-1.5 font-mono2 text-[10px] uppercase tracking-[0.18em] text-hadron-cyan">
                {chip}
              </span>
            ))}
          </div>
          <button
            data-testid="story-cta"
            onClick={() => scrollToId("contact")}
            className="group inline-flex items-center gap-3 border border-hadron-cyan text-hadron-cyan px-6 py-3.5 font-mono2 text-[11px] uppercase tracking-[0.2em] hover:bg-hadron-cyan hover:text-ink transition-colors"
          >
            {c.cta}
          </button>
        </Reveal>

        <Reveal delay={0.3}>
          <p className="mt-4 text-[11px] text-txt-3">{c.note}</p>
        </Reveal>
      </div>
    </section>
  );
};
